<template>
    <div class="redirectMenuMain" style="z-index: 3000">

        <div class="redirectMenu">

            <el-row class="redirectButtonRow">

                <span class="redirectTitle">바로가기 메뉴</span>

                <!-- <router-link :to="{name: '확인'}" style=text-decoration:none;>
                    <div class="redirectSeasonTicket" @click="resetPage">
                        <img class="seasonImg" src="@/components/image/Month.png"/>
                        <span class="redirectSubTitle">정기권 신청</span>
                    </div>
                </router-link>

                <router-link :to="{name: '정보'}" style=text-decoration:none;>
                    <div class="redirectTimeTicket">
                        <img class="timeImg" src="@/components/image/Time.png"/>
                        <span class="redirectSubTitle" @click="resetPage">시간권 구매</span>
                    </div>
                </router-link>

                <router-link :to="{name: '미납정보'}" style=text-decoration:none;>
                    <div class="redirectDefault">
                        <img class="searchImg" src="@/components/image/search.png"/>
                        <span class="redirectSubTitle2" @click="resetPage">미납요금 검색</span>
                    </div> 
                </router-link> -->

                <router-link :to="{name: '요금안내'}" style=text-decoration:none;>
                    <div class="redirectSeasonTicket" @click="resetPage">
                        <img class="seasonImg" src="@/components/image/Info.png"/>
                        <span class="redirectSubTitle">주차요금 안내</span>
                    </div>
                </router-link>

                <router-link :to="{name: '확인'}" style=text-decoration:none;>
                    <div class="redirectTimeTicket">
                        <img class="timeImg" src="@/components/image/Month.png"/>
                        <span class="redirectSubTitle" @click="resetPage">정기권 신청</span>
                    </div>
                </router-link>

                <!-- <router-link :to="{name: '실시간정보'}" style=text-decoration:none;>
                    <div class="redirectDefault">
                        <img class="searchImg" src="@/components/image/search.png"/>
                        <span class="redirectSubTitle2" @click="resetPage">실시간 주차 현황</span>
                    </div> 
                </router-link> -->

                <router-link :to="{name: '안내사항'}" style=text-decoration:none;>
                    <div class="redirectDefault">
                        <img class="searchImg" src="@/components/image/infoParklog.png"/>
                        <span class="redirectSubTitle2" @click="resetPage">위치 안내</span>
                    </div> 
                </router-link>

                <!-- <router-link :to="{name: '정기권 사용 내역'}" v-if="this.$store.state.isLogin == true" style=text-decoration:none;>
                    <div class="redirectDefault">
                        <img class="searchImg" src="@/components/image/infoParklog.png"/>
                        <span class="redirectSubTitle2" @click="resetPage">정기권 결제</span>
                    </div> 
                </router-link> -->



            </el-row>
            
        </div>
        <!--메뉴 끝-->
    </div>
</template>

<script>

export default {
    methods: {
        resetPage() {
            this.$store.isActive = false
            this.$store.isSubmit = false
        }
    }
}
</script>

<style scoped>
    @import '@/assets/css/reset.css';

    .redirectMenu {
        width: 120px;
        height: auto;
        background: hsla(0, 0%, 0%, 0.4) 0% 0% no-repeat padding-box;
        border: 1px solid #70707066;
        border-radius: 21px;
        padding-bottom: 15px;
    }

    .redirectTitle {
        width: 120px;
        height: 50px;
        text-align: center;
        font: normal normal 15px/21px Noto Sans KR-BOLD;
        letter-spacing: -0.75px;
        color: #FFFFFF;
        opacity: 1 !important;
        margin-left: 9px;
        padding-bottom: 10px;
    }

    .redirectButtonRow {
        margin-left: 11px;
        margin-top: 20px;
    }

    .redirectSeasonTicket {
        width: 100px;
        height: 100px;
        background: #35A6D0 0% 0% no-repeat padding-box;
        border-radius: 13px;
        opacity: 1 !important;
        margin-top: 15%;
    }

    .redirectTimeTicket {
        width: 100px;
        height: 100px;
        background: #358ED0 0% 0% no-repeat padding-box;
        border-radius: 13px;
        opacity: 1 !important;
        margin-top: 8%;
    }

    .redirectDefault {
        width: 100px;
        height: 100px;
        background: #266CB5 0% 0% no-repeat padding-box;
        border-radius: 13px;
        opacity: 1 !important;
        margin-top: 8%;
    }

    .redirectSubTitle {
        width: 100px;
        height: auto;
        text-align: center;
        font: normal normal normal 14px/20px Noto Sans KR;
        letter-spacing: -0.7px;
        color: #FFFFFF;
        opacity: 1 !important;
        margin-top: 7%;
        display: inline-block;
    }

    .redirectSubTitle2{
        width: 100px;
        height: auto;
        text-align: center;
        font: normal normal normal 13px/20px Noto Sans KR; /* font 조절 */
        letter-spacing: -0.7px;
        color: #FFFFFF;
        opacity: 1 !important;
        margin-top: 7%;
        display: inline-block;
    }

    /* image */
    .seasonImg {
        margin-top: 15%;
        margin-left: 10%;
        width: 80%;
    }

    .timeImg {
        margin-top: 15%;
        margin-left: 11%;
        width: 80%;
    }

    .searchImg {
        margin-top: 15%;
        margin-left: 12%;
        width: 78%;
    }

</style>